var Acr = Acr || {};

Acr.GallerySlider = function () {
  

  var $gallerySlider;
  var $gallerySwiperContainer;
  var $gallerySliderItems;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $gallerySliderDetail;
  var gallerySwiper;
  var acrGalleryDetail;
  var galleryDetailId;
  var mobilePaginationType;
  const gallerySliderItemSelector = '.js-gallery-slider-item';
  const swiperContainerSelector = '.js-swiper-container';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  const mobileMaxCards = 9; // Maximum card limit to show dots pagination, if the number of cards is greater, fractional pagination is shown

  // Initialize all HTML selectors
  function initSelectors(element) {
    $gallerySlider = element;
    $gallerySwiperContainer = $gallerySlider.querySelector(swiperContainerSelector);
    $swiperPagination = $gallerySlider.querySelector(swiperPaginationSelector);
    $arrowLeft = $gallerySlider.querySelector(arrowLeftSelector);
    $arrowRight = $gallerySlider.querySelector(arrowRightSelector);
  }

  // Initialize all necessary global variables in the component
  function initGlobalVariables() {
    var numberOfCards = $gallerySlider.querySelectorAll(gallerySliderItemSelector).length;
    mobilePaginationType = numberOfCards > mobileMaxCards ? 'fraction' : 'bullets';
  }

  // Initialize the swiper slider for the gallery
  function initGallerySliderSwiper() {
    gallerySwiper = new Swiper($gallerySwiperContainer, {
      slidesPerView: 1,
      spaceBetween: 27, // 27px of margin
      loop: true,
      pagination: {
        el: $swiperPagination,
        type: mobilePaginationType,
        clickable: true,
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft,
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true,
          },
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true,
          },
        },
        // when window width is >= 1400px
        1400: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          pagination: {
            el: $swiperPagination,
            type: 'bullets',
            clickable: true,
          },
        },
      },
      init: true,
    });

    gallerySwiper.on('slideChange', function () {
      if (Acr.TrackingManager && event.type !== 'resize') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });

    $gallerySliderItems = $gallerySlider.querySelectorAll(gallerySliderItemSelector);
  }

  // Initialize the gallery detail component
  function initGalleryDetail() {
    galleryDetailId = $gallerySlider.getAttribute('data-gallery-detail');

    if (galleryDetailId !== undefined) {
      acrGalleryDetail = new Acr.GalleryDetail();
      $gallerySliderDetail = document.getElementById(galleryDetailId);
      acrGalleryDetail.init($gallerySliderDetail);
    }
  }

  function bindEvents() {
    // Attachment of click events for each image item
    $gallerySliderItems.forEach(function (item) {
      item.addEventListener('click', openGalleryDetail);
    });
  }

  // Function to open the gallery details every time an item is clicked
  function openGalleryDetail() {
    if (galleryDetailId !== undefined) {
      var imageId = this.getAttribute('data-image-id');
      var index = this.getAttribute('data-index');
      acrGalleryDetail.openDetailview(imageId, index, true); // We set isCustomIndex to 'true', because the component could open a gallery details with more images than those shown in the slider
    }
  }

  function reset() {
    gallerySwiper.update();
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initGallerySliderSwiper();
    initGalleryDetail();
    bindEvents();
  }

  return {
    init: init,
    reset: reset,
  };
};
